// extracted by mini-css-extract-plugin
export var callCard = "_r5-0";
export var callMessageButton = "_r5-1";
export var helpIcon = "_r5-3";
export var helpIconContainer = "_r5-4";
export var verticalDivider = "_r5-2";